import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null
    };

    public static getDerivedStateFromError(error: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Uncaught error:', error, errorInfo);

        // Check if it's a ChunkLoadError
        if (error.name === 'ChunkLoadError' || error.message.includes('Loading chunk')) {
            const pageHasAlreadyBeenForceRefreshed = JSON.parse(
                window.localStorage.getItem('page-has-been-force-refreshed') || 'false'
            );

            if (!pageHasAlreadyBeenForceRefreshed) {
                window.localStorage.setItem('page-has-been-force-refreshed', 'true');
                window.location.reload();
            }
        }
    }

    private handleReset = () => {
        window.localStorage.removeItem('page-has-been-force-refreshed');
        window.location.reload();
    };

    public render() {
        if (this.state.hasError) {
            if (this.state.error?.message.includes('Loading chunk')) {
                return (
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <h2>Erro de carregamento</h2>
                        <p>Não foi possível carregar esta parte do aplicativo. Isso pode acontecer devido a uma atualização ou conexão instável.</p>
                        <button
                            onClick={this.handleReset}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            Recarregar aplicativo
                        </button>
                    </div>
                );
            }

            return (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <h2>Algo deu errado</h2>
                    <p>Ocorreu um erro inesperado.</p>
                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer'
                        }}
                    >
                        Recarregar página
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
